import CommonPop from "../CommonPop";
import classnames from 'classnames/bind';
import style from './index.module.scss';
import Input from "../../components/Input";
import ComState from "../../Api/ComState";
import AreaCodeData from "../../Api/AreaCodeData";
import NetProtocol, { Address, UserAddress } from "../../Net/NetProtocol";
import { HttpNetPost } from "../../Net/HttpNetMg";
import Common from "../../Common/Common";
import { useEffect } from "react";
import { GetCountryNames } from "../../Api/CountryData";
const className = classnames.bind(style);

const initialState = {
    inputFrom: {        // 密码输入框内容
      fullname: '',
      areacode: '',
      phonenumber: '',
      country:'',
      address: '',
      postcodes: ''
    },
    invalidValid: {     // input输入错误提示
      fullname: {flag: false, errMsg: ''},
      areacode: {flag: false, errMsg: ''},
      phonenumber: {flag: false, errMsg: ''},
      country: {flag: false, errMsg: ''},
      address: {flag: false, errMsg: ''},
      postcodes: {flag: false, errMsg: ''}
    }
}

const UseAddress = ()=>{
    const adIndex = Common.UserData.SelectAd;
    const { state, updateState } = ComState(initialState);
    const {
        inputFrom,
        invalidValid
    } = state.mdata;
    // 更新input
    const updateInputFrom = (type: string, value: string) => {
      const temp:any = {}
      temp[type] = value;
      updateState({inputFrom: Object.assign({}, inputFrom, temp)});
    }

    const validEmptyInput = (inputdata: string)=>{
      if(!inputdata){
        return false;
      }
      return true;
    }

    useEffect(()=>{
      if(adIndex > 0 && Common.UserData?.address){
        const naddress = Common.UserData.address[adIndex-1];
        updateState({
          inputFrom:{
            fullname:naddress.fullname,
            areacode:naddress.areacode,
            phonenumber:naddress.phonenum,
            country:naddress.country,
            address:naddress.address,
            postcodes:naddress.postcodes
          }
        });
      }
    }, [])

    const validAllFromItem = ()=>{
      updateState({
        invalidValid: {
          fullname: {
            flag: !validEmptyInput(inputFrom.fullname),
            errMsg: "Content cannot be empty"
          },
          areacode: {
            flag: !validEmptyInput(inputFrom.areacode),
            errMsg: "Content cannot be empty"
          },
          phonenumber: {
            flag: !validEmptyInput(inputFrom.phonenumber),
            errMsg: "Content cannot be empty"
          },
          country: {
            flag: !validEmptyInput(inputFrom.country),
            errMsg: "Content cannot be empty"
          },
          address: {
            flag: !validEmptyInput(inputFrom.address),
            errMsg: "Content cannot be empty"
          }
        }
      })
    }

    // 表单验证
    const validAllFrom = () => {
      const validMap = [
        validEmptyInput(inputFrom.fullname),
        validEmptyInput(inputFrom.areacode),
        validEmptyInput(inputFrom.phonenumber),
        validEmptyInput(inputFrom.country),
        validEmptyInput(inputFrom.address),
      ]
      return validMap.every(item => item);
    }
    const onSubmitAddress = async ()=>{
      const userInfo = Common.UserData;
      if(!userInfo){
        Common.Common.ShowLogin = true;
        return;
      }
      if(!validAllFrom()) {
        validAllFromItem();
        return;
      }
      let useradr: UserAddress = new UserAddress();
      useradr.account = userInfo.account;
      let naddress = new Address();
      naddress.fullname = inputFrom.fullname;
      naddress.areacode = inputFrom.areacode;
      naddress.phonenum = inputFrom.phonenumber;
      naddress.country = inputFrom.country;
      naddress.address = inputFrom.address;
      naddress.postcodes = inputFrom.postcodes;
      useradr.address = naddress;
      useradr.tyindex = adIndex-1;
      const resData:NetProtocol = await HttpNetPost("/setcontact", useradr, true);
      if(resData.code === 0){
        Common.Common.PopTips = "Successfully saved";
        if(adIndex > 0){
          Common.UserData.address[adIndex-1] = naddress;
        }
        else{
          if(Common.UserData.address){
            Common.UserData.address.push(naddress);
          }
          else{
            Common.UserData.address = [naddress];
          }
        }
      }
    }

    const close = ()=>{
      Common.UserData = {SelectAd:-1};
    }

    return(
        <CommonPop closeWindown={close} titlestr={adIndex>0?'Modify Address':'Add New Address'}>
            <div className={className('main')}>
              <div className={className('input_wrap')}>
                <Input
                    required
                    mode="email"
                    label={"full name"}
                    labelStyle={{color: '#97A3B0'}}
                    type="text"
                    value={inputFrom.fullname}
                    changeInputValue={value => updateInputFrom('fullname', value)}
                    invalidFlag={invalidValid.fullname.flag}
                    invalidMsg={invalidValid.fullname.errMsg}
                    placeholder={"full name"}
                    inputBlockStyle={{width: '100%'}}
                />
                
                <div className={className("phonenumber")}>
                    <div className={className("item1")}>
                    <Input
                      required
                      mode='selection'
                      label='areacode'
                      value={inputFrom.areacode}
                      changeInputValue={value => updateInputFrom('areacode', value)}
                      invalidFlag={invalidValid.areacode.flag}
                      invalidMsg={invalidValid.areacode.errMsg}
                      placeholder='+areacode'
                      inputBlockStyle={{width: '100%'}}
                      options={AreaCodeData}
                    />
                    </div>
                    <div className={className("item2")}>
                    <Input
                      required
                      mode='general'
                      label='phone number'
                      value={inputFrom.phonenumber}
                      changeInputValue={value => updateInputFrom('phonenumber', value)}
                      invalidFlag={invalidValid.phonenumber.flag}
                      invalidMsg={invalidValid.phonenumber.errMsg}
                      placeholder='phone number'
                      inputBlockStyle={{width: '100%'}}
                      optionsid="phonenumbers"
                    />
                    </div>
                </div>
                <Input
                    required
                    mode="selection"
                    label={"country (English)"}
                    labelStyle={{color: '#97A3B0'}}
                    type="text"
                    value={inputFrom.country}
                    changeInputValue={value => updateInputFrom('country', value)}
                    invalidFlag={invalidValid.country.flag}
                    invalidMsg={invalidValid.country.errMsg}
                    placeholder={"country (English)"}
                    inputBlockStyle={{width: '100%'}}
                    options={GetCountryNames()}
                    optionsid="countrynames"
                />
                <Input
                    required
                    mode="email"
                    label={"address (mother tongue)"}
                    labelStyle={{color: '#97A3B0'}}
                    type="text"
                    value={inputFrom.address}
                    changeInputValue={value => updateInputFrom('address', value)}
                    invalidFlag={invalidValid.address.flag}
                    invalidMsg={invalidValid.address.errMsg}
                    placeholder={"address (use your native language)"}
                    inputBlockStyle={{width: '100%'}}
                />
                <Input
                    mode="email"
                    label={"postcodes"}
                    labelStyle={{color: '#97A3B0'}}
                    type="text"
                    value={inputFrom.postcodes}
                    changeInputValue={value => updateInputFrom('postcodes', value)}
                    invalidFlag={invalidValid.postcodes.flag}
                    invalidMsg={invalidValid.postcodes.errMsg}
                    placeholder={"postcodes"}
                    inputBlockStyle={{width: '100%'}}
                />
              </div>
              <button className={className('submit_btn')} onClick={onSubmitAddress}>Submit</button>
            </div>
        </CommonPop>
    )
}

export default UseAddress;